import React from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import CallEndIcon from '@material-ui/icons/CallEnd';

import { Button } from '@material-ui/core';

import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		button: {
			background: theme.brand,
			color: 'white',
			borderRadius: 999,
			paddingLeft: 20,
			paddingRight: 20,
			'&:hover': {
				background: '#A8231B',
			},
			'&$focusVisible': {
				boxShadow: '0 0 0 3px rgba(217, 48, 37, 0.45)',
			},
			[theme.breakpoints.down('sm')]: {
				borderRadius: 12,
				paddingLeft: 4,
				paddingRight: 4,
			},
		},
		focusVisible: {},
	}),
);

export default function EndCallButton(props: { className?: string }) {
	const classes = useStyles();
	const { room } = useVideoContext();

	return (
		<Button
			onClick={() => room!.disconnect()}
			className={clsx(classes.button, props.className)}
			classes={{ focusVisible: classes.focusVisible }}
			startIcon={<CallEndIcon />}
			data-cy-disconnect
		>
			Leave
		</Button>
	);
}
